import React from 'react'
import SEO from '../components/SEO.jsx';
import Header from "../partials/header/Header.jsx";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb.js';
import Footer from '../container/Footer/Footer.js';
import ScrollToTop from '../components/ScrollToTop.jsx';
import './CareerContentThree.css';
const CareerContentThree= () => {
  return (
    <React.Fragment>
    <SEO title="Thirumala || Career > Career Corporate Division" />
    <Header />
    <Breadcrumb 
        image="images/bg/bgcontactus.jpg"
        // title="We are an agency located in New York"
        title="  Machine Shop Division"
        content="Home"
        contentTwo="Machine Shop Division"
    

    />
    <div className='no-career' >
   <div className='no-career-found'>
{/* card */}
    <div className='' style={{paddingBottom:"50px"}}>              
      <div className='operator card' style={{boxShadow:'10px solid green'}} >
        <div className='time '>
          <h5>11/11/2023</h5>
        </div>


        <div className='machineoperator ' >
        <h3 className='machine'>Machine Operator</h3>
        </div>

        <div className='require ' >
          <h5>We Require VMC Machine Operator  Experience Required : - 2 Years <br />Contact :- +91 8956539956</h5><br />
          <button className='article'>READ ARTICLE</button>
        </div>
        </div> 
      
      </div>
      
    </div>
    </div>
   
<Footer />
    <ScrollToTop />
</React.Fragment>
  )
}

export default CareerContentThree;
